import { CommonSheet } from 'types/types'

export interface RewardFormValues {
  currency: string
  amount: number
}

export interface RewardsDataPoint {
  day: string
  rewards: number
  tooltipLabel: string
}

export const RewardsActionIds = {
  WITHDRAW: 'WITHDRAW',
  DEPOSIT: 'DEPOSIT',
  REMOVE_ALLOCATION: 'REMOVE_ALLOCATION',
} as const

export type RewardsActionId = (typeof RewardsActionIds)[keyof typeof RewardsActionIds]

export interface RewardsAction extends CommonSheet {
  actionId: RewardsActionId
  selectedCurrency?: string
}

export interface Wallet {
  value: string
  name: string
}

export interface RewardsWithdrawFormData {
  currency: string
  withdrawToWallet: Wallet | null
  walletName: string
  maxAmount: number
  amount: string
}

export interface RewardsDepositFormData {
  currency: string
  allocateFrom: Wallet | null
  amount: string
  termsAccepted: boolean
}
